var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBubbleChartPreview(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13565_15085)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 179H200",
    stroke: "#CBCBCB",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 150H200",
    stroke: "#CBCBCB",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 120H200",
    stroke: "#CBCBCB",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 90H200",
    stroke: "#CBCBCB",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 61H200",
    stroke: "#CBCBCB",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 31H200",
    stroke: "#CBCBCB",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.9248,
    cy: 133.338,
    r: 9.92481,
    fill: "#ADB5BD"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.0526,
    cy: 106.045,
    r: 16.1278,
    fill: "#ADB5BD"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.9775,
    cy: 165.594,
    r: 9.92481,
    fill: "#868E96"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 69.2333,
    cy: 158.15,
    r: 16.1278,
    fill: "#868E96"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 85.3608,
    cy: 128.376,
    r: 9.92481,
    fill: "#ADB5BD"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 118.857,
    cy: 129.617,
    r: 16.1278,
    fill: "#373D43"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 122.579,
    cy: 169.316,
    r: 9.92481,
    fill: "#373D43"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 159.797,
    cy: 128.376,
    r: 9.92481,
    fill: "#868E96"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 188.331,
    cy: 86.1953,
    r: 9.92481,
    fill: "#868E96"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.8272,
    cy: 113.489,
    r: 9.92481,
    fill: "#ADB5BD"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 159.177,
    cy: 95.4998,
    r: 4.34211,
    fill: "#373D43"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.7029,
    cy: 102.944,
    r: 4.34211,
    fill: "#373D43"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52.4852,
    cy: 94.2596,
    r: 4.34211,
    fill: "#868E96"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.9437,
    cy: 151.327,
    r: 4.34211,
    fill: "#ADB5BD"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 130.643,
    cy: 71.9285,
    r: 4.34211,
    fill: "#ADB5BD"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 101.489,
    cy: 73.7894,
    r: 16.1278,
    fill: "#868E96"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134.985,
    cy: 96.1201,
    r: 9.92481,
    fill: "#868E96"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 159.797,
    cy: 61.3837,
    r: 16.1278,
    fill: "#ADB5BD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13565_15085"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBubbleChartPreview);
export default __webpack_public_path__ + "static/media/bubbleChartPreview.a7c05e9a55b49c56534771951de0f86e.svg";
export { ForwardRef as ReactComponent };